<template lang="pug">
  main
    NavBarFacturasIRGE
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title  Agregar Factura IRGE&nbsp
              a.button.is-black.is-rounded(@click='backPage')
                i.fas.fa-times
        .columns
          .column.is-4.is-offset-4.has-text-centered
            .field
              label.label No. de Embarque
              .control.has-icons-left.has-icons-right
                input.input.is-dark(
                  type='text', 
                  placeholder='Número de Embarque',
                  v-model="embarque"
                )
            .field
              .file.is-primary.has-name
                label.file-label
                  input.file-input(type='file' name="fileFactura" ref="myFactura" @change="previewFileFactura" accept="application/pdf")
                  span.file-cta
                    span.file-icon
                      i.fas.fa-upload
                    span.file-label
                      | Subir Factura &mldr;
                  span.file-name
                    | {{ fileFactura.name }}
            .field
              .file.is-success.has-name
                label.file-label
                  input.file-input(type='file' name="fileXml" ref="myXml" @change="previewFileXml" accept="text/xml")
                  span.file-cta
                    span.file-icon
                      i.fas.fa-upload
                    span.file-label
                      | Subir XML &mldr;
                  span.file-name
                    | {{ fileXml.name }}
            br
            br
            a.button.is-black.is-block(@click="enviarFacturas" :disabled="isDisabled") Guardar
        .columns.column-blanco
</template>

<script>
  import Loader from '../../shared/Loader.vue'
  import NavBarFacturasIRGE from '../layout/NavBarFacturasIRGE.vue'
  import facturasServices from '../../../services/facturas/facturas'
  import moment from 'moment'

  export default {
    name: 'Facturas',
    components: { Loader, NavBarFacturasIRGE },
    data() {
      return {
        isLoading: true,
        embarque: '',
        fileFactura: '',
        fileXml: '',
        fecha_fact: '',
        fecha_jornada: '',
        isDisabled: true
      }
    },
    watch: {
      embarque () {
        if (this.embarque === '' ) {
          this.isDisabled = true
        } else {
          if (!this.fileFactura) {
            this.isDisabled = true
          } else {
            if (!this.fileXml) {
              this.isDisabled = true
            } else {
              this.isDisabled = false
            }
          }
        }
      },
      fileFactura () {
        if (this.embarque === '' ) {
          this.isDisabled = true
        } else {
          if (!this.fileFactura) {
            this.isDisabled = true
          } else {
            if (!this.fileXml) {
              this.isDisabled = true
            } else {
              this.isDisabled = false
            }
          }
        }
      },
      fileXml () {
        if (this.embarque === '' ) {
          this.isDisabled = true
        } else {
          if (!this.fileFactura) {
            this.isDisabled = true
          } else {
            if (!this.fileXml) {
              this.isDisabled = true
            } else {
              this.isDisabled = false
            }
          }
        }
      }
    },
    methods: {
      iniciarComponente() {
        setTimeout(() => {
          this.isLoading = false
        }, 500)
      },
      previewFileFactura() {
        let file = this.$refs.myFactura.files
        this.fileFactura = file[0]
        console.log(this.fileFactura)
      },
      previewFileXml() {
        let file = this.$refs.myXml.files
        this.fileXml = file[0]
        console.log(this.fileXml)
      },
      enviarFacturas () {
        if (!this.isDisabled) {

          this.isLoading = true
  
          let embarqueLong = this.embarque.length
          let fileFacLong = this.fileFactura.size
          let fileXmlLong = this.fileXml.size
  
          facturasServices.getEmbarqueIndIRGE(this.embarque)
            .then(res => {
              console.log(res)
              if (res.length > 0 ) {
                let ahora = moment()
                this.fecha_fact = ahora.format('YYYY-MM-DD HH:mm:ss')
                this.fecha_jornada = res[0].fecha_reporte
                console.log(this.fecha_fact)
                console.log(this.fecha_jornada)
                let idPg = res[0].pg
                
                facturasServices.addFactura_XmlIRGE(this.embarque, this.fecha_fact, this.fecha_jornada, this.fileFactura, this.fileXml)
                  .then(response => {
                      console.log(response)
                      if (response.success) {

                        setTimeout(() => {
                          this.embarque = ''
                          this.fileFactura = ''
                          this.fileXml = ''
                          this.isLoading = false
                          let toast = this.$toasted.show(`${response.respuesta}`, {
                            theme: "toasted-primary", 
                            position: "bottom-right", 
                            duration : 3500,
                            iconPack: 'fontawesome',
                            icon: 'exclamation-triangle',
                            action : {
                              text : 'Ok',
                              onClick : (e, toastObject) => {
                                toastObject.goAway(0)
                              }
                            
                            }
                          })
                        }, 2000)
                      } else {
                        let toast = this.$toasted.show(`${response.respuesta}`, { 
                          theme: "toasted-primary", 
                          position: "bottom-right", 
                          duration : 1500,
                          iconPack: 'fontawesome',
                          icon: 'exclamation-triangle',
                          action : {
                            text : 'Ok',
                            onClick : (e, toastObject) => {
                              toastObject.goAway(0)
                            }
                          },
                        })
                      }
                  })
              } else {
                let toast = this.$toasted.show('No se encontró el embarque', {
                  theme: "toasted-primary", 
                  position: "bottom-right", 
                  duration : 3500,
                  iconPack: 'fontawesome',
                  icon: 'exclamation-triangle',
                  action : {
                    text : 'Ok',
                    onClick : (e, toastObject) => {
                      toastObject.goAway(0)
                    }
                  },
                })
                this.embarque = ''
                this.fileFactura = ''
                this.fileXml = ''
                this.isLoading = false
              }

            })


        }
      },
      backPage () {
        this.$router.back()
      },
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/grupos_Componentes/IRGE/NewFacturaIRGE.vue